export default __webpack_public_path__ + "static/media/introBgMb.7f55ab9f.png";